// Define platforms list
const CARD_LIST = [
  {
    id: 'horizontal',
    title: 'Horizontal',
  },
  {
    id: 'vertical',
    title: 'Vertical',
  },
];

export const getCardLabel = (val) => {
  let label = '';

  CARD_LIST.forEach((p) => {
    if (label === '' && p.id === val) {
      label = p.title;
    }
  });

  return label;
};

export default CARD_LIST;
